import React, { useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { HooksDisplayGrid } from 'ui-components/components/hooks-display-grid';

import GridLoading from '../../../../components/grid-loading';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../../store/global-selectors';
import { getFreightGridRequest, setSelectedFreightShipmentIds } from '../../../../store/ltl/grid/ltl.grid.actions';
import { openLtlWizard } from '../../../../store/ltl/ltl.actions';
import { defaultFreightColumns } from './columns';
import { LtlShipmentsGridPlaceholder } from './ltl-shipments-grid-placeholder';

import gridPageStyle from '../../../grid-page.module.less';

const QUOTED_STATUS = 'Quoted';
const BOOKED_STATUS = 'Booked';
const getColumnId = ({ id }: { id: string }) => id;

export const LtlShipmentsGrid = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const currentPageShipmentIds = useSelector(Global.selectLtlGridCurrentPageShipmentIds);
  const isLoading = useSelector(Global.selectLtlGridIsLoading);
  const page = useSelector(Global.selectLtlGridPage);
  const pageSize = useSelector(Global.selectLtlGridPageSize);
  const selected = useSelector(Global.selectLtlGridSelectedShipmentIds);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [columns, setColumns] = useState<any[]>(defaultFreightColumns);

  const gridData = useMemo(
    () => (isLoading ? emptyArray : currentPageShipmentIds.map((id: number) => ({ id: String(id) }))),
    [currentPageShipmentIds, isLoading],
  );

  const handleSelectedChanged = useCallback(
    (selectedIds: string[]) => {
      dispatch(setSelectedFreightShipmentIds(selectedIds));
    },
    [dispatch],
  );

  const handleRowDoubleClick = useCallback(
    (row: { id: string }) => {
      const state = store.getState();
      const shipment = Global.selectEntitiesFreightShipmentById(state, { freightShipmentId: row.id });
      if (shipment?.status === BOOKED_STATUS) {
        dispatch(openLtlWizard({ mode: 'view-booked', freightShipmentId: row.id }));
      } else if (shipment?.status === QUOTED_STATUS) {
        dispatch(openLtlWizard({ mode: 'load-saved-quote', freightShipmentId: row.id }));
      }
    },
    [dispatch, store],
  );

  const handleOrderByChanged = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (updatedColumns: any[]) => {
      setColumns(updatedColumns);
      dispatch(getFreightGridRequest(page, pageSize));
    },
    [dispatch, page, pageSize],
  );

  const handleColumnsChanged = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (updatedColumns: any[]) => {
      setColumns(updatedColumns);
    },
    [],
  );

  return (
    <div className={gridPageStyle.grid}>
      {isLoading && <GridLoading />}
      {!isLoading && (
        <HooksDisplayGrid
          // @ts-expect-error HooksDisplayGrid interface not defined
          columns={columns}
          data={gridData}
          getColumnId={getColumnId}
          onColumnsChanged={handleColumnsChanged}
          onOrderByChanged={handleOrderByChanged}
          onRowDoubleClick={handleRowDoubleClick}
          onSelectedChanged={handleSelectedChanged}
          placeholder={<LtlShipmentsGridPlaceholder />}
          selected={selected}
        />
      )}
    </div>
  );
};
